import request from '@/util/http'

// 教室查询-列表查询
export const getClassRoomPage=(params)=>request({
    url: '/hq/classroom/page',
    method: 'get',
    params
})
//教室查询-下载二维码
export const getClassRoomDownId=(params)=>request({
    url: '/hq/classroom/roomQR',
    method: 'get',
    params
})

// 教室查询-批量下载二维码
export const getClassRoomDown=(params)=>request({
    url: '/hq/classroom/exportQRzip',
    method: 'post',
    data:params
})

// 教室查询-获取楼栋名称
export const getBuildList=()=>request({
    url: '/hq/classroom/buildList',
    method: 'get',
})

// 教室查询-数据字典
export function getDicType (type) {
    return request({
        url: '/admin/dict/type/' + type,
        method: 'get',
    })
}
